import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const steps = [{
  emoji: '🛒',
  title: 'Realizás tu compra',
  desc: 'De forma 100% segura con Mercado Pago, tarjeta o transferencia bancaria.',
  tint: 'bg-teal-50/70 border-teal-100'
}, {
  emoji: '📧',
  title: 'Recibís acceso inmediato por email',
  desc: 'En pocos minutos llega a tu casilla con todo listo para descargar.',
  tint: 'bg-amber-50/70 border-amber-100'
}, {
  emoji: '📂',
  title: 'Descargás todos los PDF',
  desc: 'Todos los tomos y bonos en PDF en un solo lugar organizado.',
  tint: 'bg-coral-50/60 border-coral-100'
}, {
  emoji: '🖨️',
  title: 'Imprimís lo que necesites',
  desc: 'Imprimílos en casa o en una fotocopiadora. O usalos directo desde el celular o tablet.',
  tint: 'bg-stone-50/60 border-stone-200'
}, {
  emoji: '🛡️',
  title: 'Comenzás hoy mismo',
  desc: 'Abrís el Tomo 1 y presentás los primeros pictogramas. Los primeros resultados aparecen en los primeros 7 días.',
  tint: 'bg-teal-50/60 border-teal-100'
}];
export function DeliverySection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-53">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-54">
        <div className="text-center mb-10" data-id="element-55">
          <span className="text-amber-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-56">
            Simple y al instante
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-teal-900" data-id="element-57">
            ¿Cómo recibo el material?
          </h2>
        </div>

        <ol className="relative" data-id="element-58">
          {steps.map((step, i) => <li key={i} data-id="element-59">
              <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className={`flex items-center gap-4 rounded-2xl border shadow-sm p-5 ${step.tint}`} data-id="element-60">
                <div className="relative flex-shrink-0" data-id="element-61">
                  <div className="w-12 h-12 rounded-xl bg-white shadow-sm flex items-center justify-center text-2xl" data-id="element-62">
                    <span aria-hidden="true" data-id="element-63">{step.emoji}</span>
                  </div>
                  <span className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-teal-700 text-white text-xs font-bold flex items-center justify-center" data-id="element-64">
                    {i + 1}
                  </span>
                </div>
                <div data-id="element-65">
                  <h3 className="font-bold text-teal-900 text-lg leading-tight" data-id="element-66">
                    Paso {i + 1} · {step.title}
                  </h3>
                  <p className="text-sm text-stone-600 mt-1" data-id="element-67">{step.desc}</p>
                </div>
              </motion.div>

              {i < steps.length - 1 && <div className="flex justify-center py-2" aria-hidden="true" data-id="element-68">
                  <ChevronDown className="w-6 h-6 text-amber-500" data-id="element-69" />
                </div>}
            </li>)}
        </ol>
      </div>
    </section>;
}